import { instance } from "libs/api";

import { AuditAlertResponse } from "../../auditLog.types";
import { ApiRoutesAuditLog } from "../../constants";

export const requestGetAuditAlertById = async (
  alertId: string
): Promise<AuditAlertResponse> => {
  return await instance.get(`${ApiRoutesAuditLog.AuditAlerts}/${alertId}`);
};
